export interface PoiCategoryLocalizedValue {
  name?: string
  code?: string
}

export interface PoiCategoryLike {
  id?: string
  icon?: string
  localizedData?: Record<string, PoiCategoryLocalizedValue>
}

export function resolveCategoryCode(
  localizedData?: Record<string, PoiCategoryLocalizedValue>,
  preferredLanguages: string[] = ['en', 'vi-south'],
): string {
  if (!localizedData) {
    return ''
  }

  for (const language of preferredLanguages) {
    const name = localizedData[language]?.name?.trim()
    if (name) {
      return name
    }

    const code = localizedData[language]?.code?.trim()
    if (code) {
      return code
    }
  }

  const fallback = Object.values(localizedData).find(
    (item) => item.name?.trim() ?? item.code?.trim(),
  )
  const fallbackName = fallback?.name?.trim()
  if (fallbackName) {
    return fallbackName
  }

  return fallback?.code?.trim() ?? ''
}

export function resolvePoiCategoryName(
  category?: PoiCategoryLike | null,
  preferredLanguages: string[] = ['en', 'vi-south'],
): string {
  return (
    resolveCategoryCode(category?.localizedData, preferredLanguages) || (category?.id?.trim() ?? '')
  )
}
